import {styled} from '@fluentui/react';
import {SiteFooterBase} from './SiteFooter.base';
import {siteFooterStyles} from './SiteFooter.styles';
import {ISiteFooterProps, ISiteFooterStyleProps, ISiteFooterStyles} from './SiteFooter.types';

export const SiteFooter = styled<ISiteFooterProps, ISiteFooterStyleProps, ISiteFooterStyles>(
  SiteFooterBase,
  siteFooterStyles,
);
